// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"e127ba62","646":"34372eee"}[chunkId] + ".chunk.js";
};